import React from 'react';
import styles from '../index.module.scss';

type Props = {
  children: React.ReactNode;
};

export const BreadcrumbItem: React.FC<Props> = ({ children }) => (
  <li className={styles.item}>{children}</li>
);
